// extracted by mini-css-extract-plugin
module.exports = {"container":"EmailPopup_container_2r5Yh","popup":"EmailPopup_popup_YOU2R","dialog":"EmailPopup_dialog_1P7E1","btn_cancel":"EmailPopup_btn_cancel_9nxCx"};